import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import InputComponent from '../../../core/components/input/InputComponent';
import { PanelSubSectionComponent } from '../../../core/components/oldPanel/OldPanelComponent';
import ButtonComponent from '../../../core/components/button/ButtonComponent';
import { useLogin, useAuth } from '../useAuth';

type LoginContainerType = {
  onCloseModal: () => void;
  onSwitchToResetPassword?: () => void;
};

export const LoginContainer: FC<LoginContainerType> = ({ onCloseModal, onSwitchToResetPassword }) => {
  const { t } = useTranslation();
  const { isLoadingLogin, login, loginError, setLoginError } = useLogin();
  const {
    email, emailError, isValidEmail,
    password, passwordError, isValidPassword,
    onChangeEmail, onChangePassword,
  } = useAuth();

  const onLogin = async () => {
    try {
      await login(email, password);
      onCloseModal();
      setLoginError(undefined);
    } catch (error) {
      if (error instanceof Error) setLoginError(error.message);
    }
  };

  return (
    <>
      <PanelSubSectionComponent>
        <p className="mb-[4px]">{t('auth.emailLabel')}</p>
        <InputComponent onChange={onChangeEmail} value={email} placeholder={t('auth.emailPlaceholder')} errorText={emailError} />
      </PanelSubSectionComponent>
      <PanelSubSectionComponent>
        <p className="mb-[4px]">{t('auth.passwordLabel')}</p>
        <InputComponent onChange={onChangePassword} value={password} placeholder={t('auth.passwordPlaceholder')} type="password" errorText={passwordError} />
        {onSwitchToResetPassword && (
          <button type="button" onClick={onSwitchToResetPassword} className="mt-2 text-blue-500 hover:text-blue-700 text-sm underline cursor-pointer">
            {t('auth.forgotPassword')}
          </button>
        )}
      </PanelSubSectionComponent>
      {loginError && <div className="text-danger text-14">{loginError}</div>}
      <ButtonComponent
        className="mt-16"
        text={t('auth.loginButton')}
        onClick={onLogin}
        isLoading={isLoadingLogin}
        isDisabled={isLoadingLogin || !isValidEmail || !isValidPassword}
      />
    </>
  );
};
